 import React, { Component, Fragment } from "react";
import styled from "styled-components";
import ReactButton from "common-components/Buttons";
import { media , isMobile } from "utils/style";
import CommonContainer from "common-components/Container";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { convertStringToElements } from "@vds/html-parsers";
import { TitleLockup } from "@vds/type-lockups";
import { Feature,Body,Title } from "@vds/typography"
import Alert from "common-components/Alert";
import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import FetchPageContent from "../../../hoc/FetchPageContent";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions"
import { createDocVerification } from "./actions/commonFormerCustomerAPI";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { Redirect } from "react-router-dom";
class FormerCustomerVerifyIdentity extends Component {


  componentDidMount() {
    if (checkNestedObject(this.props.breadCrumbs, "landingPage")) {
      const { breadCrumbs } = this.props;
      this.props.setBreadcrumbList([
        { label: breadCrumbs.landingPage, path: "/privacy/your-data" },
        { label: breadCrumbs.VerifyYourID, path: "/privacy/your-data/former-customer" },
      ]);
    }
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("former customer", this.props.pageContent.sc_pagetitle);
    }
  }

  handleClick = () => {
    let { location, uuid } = this.props;
    let intent = location.state.data.currentIntent && location.state.data.currentIntent === "delete" ? "Delete" :
      location.state.data.currentIntent && location.state.data.currentIntent === "correct" ? "Correct" :
        location.state.data.currentIntent && location.state.data.currentIntent === "download" ? "Download" : "";
    let isMitekDoc = "Y";

    let processActionValue = "GetEnforceLink";

    var DocVerifyData = {
      caseId: this.props.caseId,
      email: location.state.data.emailId,
      processAction: processActionValue,
      applicationId: uuid ? uuid : null,
      intent: intent ? intent : null,
      serviceType: location.state && location.state.data.serviceType ? location.state.data.serviceType : null,
      isOptOut: location.state.data && location.state.data.isOptOut ? location.state.data.isOptOut : null,
      isMitekDoc: isMitekDoc ? isMitekDoc : null
    }
    this.props.createDocVerification(DocVerifyData).then(() => {
      if (!this.props.error) {
        return (window.location.href = `${this.props.gemaltoLink}`);
      }
    })
  }

  render() {
    const { pageContent, loading, location } = this.props;
    if (!pageContent) {
      if (location.state.data.serviceType === "guest") {
        return <Redirect to="/privacy/your-data/guest-landing" />;
      } else if (location.state.data.serviceType === "former") {
        return <Redirect to="/privacy/your-data/former-customer" />;
      }
    }

    if (loading) {
      return <RectangleLoader id={"formerLoader"} />;
    }

    return (
      <Fragment>
        <div>
          <Container>
          {/* VDS DPCMP-3786 ,DPCMP-3784 */}

          <TitleLockup
                  viewport={isMobile ? "mobile": "desktop"}
                  data={{
                  title: {
                    size: 'titleXLarge',
                    bold: false,
                    // primitive: 'h1',
                    children: pageContent.section_title
                  },
                  subtitle : {
                    size: 'titleMedium',
                    primitive: 'p',
                    children: 
                    <div className="description">
                      {convertStringToElements(pageContent.section_description)}
                    </div>
                  }                  
                  }}
            />
            
            <Div>
              <div className="ButtonContainer">
                <Button
                  onClick={this.handleClick}
                  background={"#0000"}
                >
                  {pageContent.buttons[0].text}
                </Button>
              </div>
            </Div>

          </Container>
          {this.props.error ? (
            <Alert alertType="error">{convertStringToElements(this.props.error)}</Alert>
          ) : null}
        </div>
      </Fragment>
    );
  }
}


FormerCustomerVerifyIdentity.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object
};

const mapStateToProps = ({ pageContent: { govtID_primer: pageContent, breadCrumbs }, caseCreation: { caseId },
  loadingAndErrorState,
  getUuid: { uuid },
  formerVerifyIdData: { gemaltoLink } }) => ({
    pageContent,
    breadCrumbs,
    caseId,
    loading: loadingAndErrorState.loading,
    error: loadingAndErrorState.error,
    uuid,
    gemaltoLink
  });

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, setBreadcrumbList, createDocVerification }
  ),
  FetchPageContent
)(FormerCustomerVerifyIdentity);

const Button = styled(ReactButton)`
  margin-right: 28px;
  margin-top:48px;

  ${media.mobile`
    margin-right: 0;
  `}
`;


const Container = styled(CommonContainer)`
  margin: 0;
  padding: 64px 20px ;

  ${media.mobile`
    padding: 48px 16px ;
  `}
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  font-weight: 300;
  width: 486px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;

  ${media.mobile`
   max-width: 100%;
   font-style: normal;
   font-weight: 400;
   font-size: 32px;
    line-height: 36px;
`}

`;

const Div = styled.div`
  width: 490px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 20px;

  .description {
    margin : 32px 0px 20px 0px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 20px;
  }
  
  p {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 20px;
  }

  ${media.mobile`
    max-width: 100%;
    font-size: 16px;
  `}
`;

